import { Skeleton, SkeletonBadge, SkeletonButton, SkeletonCard } from 'shared/components/ui/Skeleton';

// Mesmo desenho do <ArenaCard>: status + nota, nome + bairro, endereço, tags e preço/CTA.
export function ArenaCardSkeleton() {
  return (
    <SkeletonCard className="flex flex-col">
      <div className="flex items-center justify-between">
        <SkeletonBadge className="w-24" />
        <Skeleton className="h-4 w-16" />
      </div>
      <div className="mt-4 flex items-start justify-between gap-2">
        <Skeleton className="h-5 w-40" />
        <SkeletonBadge className="w-16" />
      </div>
      <Skeleton className="mt-2 h-3 w-4/5" />
      <div className="mt-4 flex gap-2">
        <Skeleton className="h-6 w-20 rounded-full" />
        <Skeleton className="h-6 w-16 rounded-full" />
        <Skeleton className="h-6 w-24 rounded-full" />
      </div>
      <div className="mt-4 flex items-center justify-between border-t border-border/40 pt-4">
        <div>
          <Skeleton className="h-2.5 w-16" />
          <Skeleton className="mt-2 h-5 w-20" />
        </div>
        <SkeletonButton className="w-28" />
      </div>
    </SkeletonCard>
  );
}
